import { syncHistoryWithStore } from 'react-router-redux';
import store from './store';
import browserHistory from './util/browserHistory';

export function createHistory(store) {
  return syncHistoryWithStore(browserHistory, store);
}

const history = createHistory(store);

export default history;



// WEBPACK FOOTER //
// ./js/history.js